import React, { Children, ReactNode } from 'react';
import styled from 'styled-components';
import { assertCondition } from '../../../utils/types';
import { theme } from '../../../styles/theme';

interface IProps {
  children: ReactNode;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 240px 24px 240px;
`;

const Separator = styled.div`
  padding-top: 5px;
  text-align: center;
  font-size: 12px;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
`;

const BetweenFields = ({ children }: IProps) => {
  const arrayOfChildren = Children.toArray(children);

  assertCondition(arrayOfChildren.length === 2);

  return (
    <Container>
      {arrayOfChildren[0]}
      <Separator>~</Separator>
      {arrayOfChildren[1]}
    </Container>
  );
};

export default BetweenFields;
